import { useLocation } from 'react-router-dom';

export function useIsOrgRoutePath() {
  const location = useLocation();
  return location.pathname.split('/')[1] === 'organization';
}
